import { GMNClosureTask } from "@nens/brostar/uploadapi-client";
import { SchemaForFormData } from "@nens/shared-utils";

import { getDocsLinkMarkdown, getTitleAddon } from "@/libs/form-utils";
import { FormType } from "@/types/form-types";

import { pickGmnLibraryFields } from "../../../schema/gmn-schema-library";

export const getGmnClosureSchema = (
  type: FormType | undefined
): SchemaForFormData<GMNClosureTask> => ({
  type: "object",
  title: `GMN-Beeindigen ${getTitleAddon(type)}`,
  description: `Dit is het GMN Beeindigen formulier. Stuur dit op om je Meetnet af te sluiten. ${getDocsLinkMarkdown(
    "GMN"
  )}`,
  required: ["metadata", "sourcedocumentData"],
  properties: {
    metadata: {
      type: "object",
      required: ["projectNumber", "broId", "qualityRegime", "deliveryAccountableParty"],
      properties: pickGmnLibraryFields([
        "projectNumber",
        "broId",
        "qualityRegime",
        "deliveryAccountableParty",
      ]),
    },
    sourcedocumentData: {
      type: "object",
      required: ["endDateMonitoring"],
      properties: pickGmnLibraryFields(["endDateMonitoring"]),
    },
  },
});
